// extracted by mini-css-extract-plugin
module.exports = {"whiteBtn":"style_whiteBtn__3bhyz"};